// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"fafdefab","864":"f0137b1e"}[chunkId] + ".chunk.css";
};